import styled from 'styled-components';

export const OfflineNotificationContainer = styled.div`
  display: flex;
  padding: 8px;
  align-items: flex-start;
  padding: 4px 16px;
  width: 100%;
  background-color: ${({ theme }) => theme.palette.info.light};
`;

export const OfflineNotificationInternalContainer = styled.div`
  display: flex;
  padding: 8px 0;
  flex-direction: row;
  gap: 12px;
  align-items: flex-start;
`;

export const OfflineNotificationTitle = styled.span`
  font-size: 16px;
  color: ${({ theme }) => theme.palette.primary.dark};
`;

export const OfflineNotificationText = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.text.secondary};
  margin: 0;
`;
